import React, { useState } from 'react';
import './App.css';
import Matcheo from './pages/Matcheo';
import SplitViewMatcheo from './pages/SplitViewMatcheo';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function AppContent() {
  const { currentUser, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('matcheo');
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Show login page if user is not authenticated
  if (!currentUser) {
    return <Login />;
  }

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  // Extract first name from email
  const getUserName = () => {
    if (currentUser?.displayName) {
      return currentUser.displayName.split(' ')[0];
    }
    if (currentUser?.email) {
      return currentUser.email.split('@')[0];
    }
    return 'Usuario';
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="app-header">
        <div className="header-left">
          <img src="/pulpou-logo.svg" alt="Pulpou" className="logo-pulpou" />
          <div className="logo-divider"></div>
          <img src="/Abbott Logo.png" alt="Abbott" className="logo-abbott" />
        </div>
        <div className="header-right">
          <div className="user-menu-container">
            <button
              className="user-greeting"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              Hi {getUserName()}
              <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" style={{ marginLeft: '4px' }}>
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"/>
              </svg>
            </button>
            {showUserMenu && (
              <div className="user-menu-dropdown">
                <div className="user-menu-email">{currentUser.email}</div>
                <button onClick={handleLogout} className="user-menu-logout">
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd"/>
                  </svg>
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Navigation Tabs */}
      <nav className="main-nav">
        <div className="nav-container">
          <div className="nav-tabs">
            <button
              className={`nav-tab ${activeTab === 'matcheo' ? 'active' : ''}`}
              onClick={() => setActiveTab('matcheo')}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
              </svg>
              MAESTRO
            </button>
            <button
              className={`nav-tab ${activeTab === 'split-view' ? 'active' : ''}`}
              onClick={() => setActiveTab('split-view')}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm8 0a1 1 0 011-1h4a1 1 0 011 1v12a1 1 0 01-1 1h-4a1 1 0 01-1-1V4z" clipRule="evenodd"/>
              </svg>
              GESTIÓN MATCHEO
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main-content">
        {activeTab === 'split-view' ? (
          <SplitViewMatcheo />
        ) : (
          <Matcheo />
        )}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
